import xs from "xstream/index";
import flattenConcurrently from "xstream/extra/flattenConcurrently";
import * as actions from "../actions";
import { getApiException } from "../Apis/apiErrors";
import * as AuthRequests from "../authentication/cycles/requests";

// Requests whose failures are either expected while anonymous (login/session probes) or are
// already reported inline by their own module (application, api product, ticket, organization
// create). Everything else that comes back with an exception body is surfaced as a toast.
const SILENT_CATEGORIES = new Set([
  ...Object.values(AuthRequests),
  "requestCsrfToken",
  "requestCheckIfAnalyticsAreEnabled",
  "requestAggregatePerEndpointPerDay",
  "requestAggregatePerEndpointPerDayStatistics", // the category cycles/analytics.js actually uses
  "requestAggregateStatistics",
  "getToken",
  "createApplication",
  "createTerminalApplication",
  "deleteApplication",
  "deleteApplicationClientSecret",
  "editApplication",
  "fetchAllApplications",
  "fetchApplications",
  "fetchAllowedGrantTypesForCreate",
  "fetchAllowedGrantTypesForEdit",
  "fetchAllowedGrantTypesForTerminal",
  "fetchApiProduct",
  "fetchApplicationViaList",
  "fetchApplicationViaOrg",
  "fetchComparisonTable",
  "fetchOrganizationsForNames",
  "resetApplicationClientSecret",
  "subscribeApiProductToApplication",
  "unsubscribeApiProductFromApplication",
  "validatePsdCertificate",
  "createTicket",
  "updateTicket",
  "createOrganization",
]);

const bodyOf = (response) =>
  (response && response.body) ||
  (response && response.response && response.response.body) ||
  null;

const categoryOf = (response) =>
  (response && response.request && response.request.category) || null;

export function notifyApiErrors(sources) {
  const action$ = sources.HTTP.select()
    .map((response$) => response$.replaceError((err) => xs.of(err)))
    // Every in-flight request must be followed: plain flatten() would switch to the newest
    // response stream and silently drop the ones still pending.
    .compose(flattenConcurrently)
    .filter((response) => {
      const category = categoryOf(response);
      if (category && SILENT_CATEGORIES.has(category)) return false;
      return !!getApiException(bodyOf(response));
    })
    .map((response) =>
      actions.apiErrorNotified({
        exception: bodyOf(response).exception,
        category: categoryOf(response),
      })
    );

  return {
    ACTION: action$,
  };
}
